export const GET_ALL_INFORMATION_REQUEST = "GET_ALL_INFORMATION_REQUEST"
export const GET_ALL_INFORMATION_REQUEST_SUCCESS = "GET_ALL_INFORMATION_REQUEST_SUCCESS"
